// src/app/routes.jsx
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import AuthGuard from "./auth/AuthGuard";
import ExpLayout from "./components/ExpLayout/ExpLayout";
import rtAdDashboard from "./views/dashboard/rtAdDashboard";
import NotFound from "./views/sessions/NotFound";
import rtPbSession from "./views/sessions/rtPbSession";
import rtAdExamLoc from "./views/pages_admin/exam_loc/rtAdExamLoc";
import rtAdExamImpSeries from "./views/pages_admin/exam_imp_series/rtAdExamImpSeries";
import rtAdExamImp from "./views/pages_admin/exam_imp/rtAdExamImp";
import rtAdExamSheet from "./views/pages_admin/exam_sheet/rtAdExamSheet";
import rtAdUserGroup from "./views/pages_admin/user_group/rtAdUserGroup";
import rtAdExamApplicants from "./views/pages_admin/exam_applicants/rtAdExamApplicants";
import rtAdPricePolicy from "./views/pages_admin/price_policy/rtAdPricePolicy";
import rtAdExamScores from './views/pages_admin/exam_scores/rtAdExamScores';
import rtAdMaintenance from './views/pages_admin/maintenance/MaintenanceRoutes';
import rtAdMenuCtrl from './views/pages_admin/menu_ctrl/rtAdMenuCtrl';
import rtUsLeet from "./views/pages_user/leet/rtUsLeet";
import rtUsG5 from "./views/pages_user/g5/rtUsG5";
import rtUsG7 from "./views/pages_user/g7/rtUsG7";
import rtUsG72 from "./views/pages_user/g72/rtUsG72";
import rtUsBar from "./views/pages_user/bar/rtUsBar";
import rtPbLeet from "./views/pages_pub/leet/rtPbLeet";
import rtPbG5 from "./views/pages_pub/g5/rtPbG5";
import rtPbG7 from "./views/pages_pub/g7/rtPbG7";
import rtPbG72 from "./views/pages_pub/g72/rtPbG72";
import rtPbBar from "./views/pages_pub/bar/rtPbBar";
import rtSs from "./views/pages_sys/rtSs";
import rtAdPages from "./views/pages/rtAdPages";
import rtPrG5 from "./views/pages_predict/g5/rtPrG5";
import rtPrG7 from "./views/pages_predict/g7/rtPrG7";
import rtPrLeet from "./views/pages_predict/leet/rtPrLeet";
import rtPrAdSetExam from "./views/pages_predict_admin/set_exam/rtPrAdSetExam";
import rtPrAdScore from "./views/pages_predict_admin/score/rtPrAdScore"
import rtPrAdScoreStat from "./views/pages_predict_admin/score_stat/rtPrAdScoreStat";
import rtPrAdScoreStatDetail from "./views/pages_predict_admin/score_stat_detail/rtPrAdScoreStatDetail";
import rtPrAdSurveyList from "./views/pages_predict_admin/survey_list/rtPrAdSurveyList";
import Landing from './views/landing/Landing';
import { Navigate } from 'react-router-dom';

const JwtLogin = Loadable(lazy(() => import("./views/sessions/login/JwtLogin")));
const JwtRegister = Loadable(lazy(() => import("./views/sessions/register/JwtRegister")));
const UserLogin = Loadable(lazy(() => import("./views/pages_user/g5/Login")));

const routes = [
  // Landing page as the root route
  { path: "/", element: <Landing /> },
  ...rtPbLeet,
  ...rtPbG5,
  ...rtPbG7,
  ...rtPbG72,
  ...rtPbBar,
  ...rtPbSession,
  ...rtUsLeet,
  ...rtUsG5,
  ...rtUsG7,
  ...rtUsG72,
  ...rtUsBar,
  ...rtPrG5,
  ...rtPrG7,
  ...rtPrLeet,

  // Admin routes
  {
    path: "/admin/*",
    element: (
      <AuthGuard>
        <ExpLayout />
      </AuthGuard>
    ),
    children: [
      //{ path: "", element: <Navigate to="dashboard" /> }, // Default admin page
      ...rtAdPages,
      ...rtAdDashboard,
      ...rtAdExamLoc,
      ...rtAdExamImpSeries,
      ...rtAdExamImp,
      ...rtAdExamSheet,
      ...rtAdUserGroup,
      ...rtAdExamApplicants,
      ...rtAdPricePolicy,
      ...rtAdExamScores,
      ...rtAdMaintenance,
      ...rtAdMenuCtrl,
      ...rtPrAdSetExam,
      ...rtPrAdScore,
      ...rtPrAdScoreStat,
      ...rtPrAdScoreStatDetail,
      ...rtPrAdSurveyList,
    ]
  },

  // User routes
  // {
  //   path: "/user/*",
  //   element: (
  //     <AuthGuard>
  //       <ExpLayout />
  //     </AuthGuard>
  //   ),
  //   children: [
  //     //{ path: "", element: <Navigate to="dashboard" /> }, // Default user page
  //   ]
  // },

  // Public routes


  // Auth routes
  { path: "/admin/login", element: <JwtLogin /> },
  { path: "/user/login", element: <UserLogin /> },
  // Uncomment to register sysadmin(sysadmin/4452, admin/1234, operator/7777)
  { path: "/session/register", element: <JwtRegister /> },

  ...rtSs,
  // 404 route
  { path: "*", element: <NotFound /> }
];

export default routes;